const enCommon = {
  welcome: "Welcome",
  language: "Language",
  rolesManagement: "Roles and Permissions Management",
  platformManager: "Platform Manager",
  companies: "Companies",
  users: "Users",
  createRole: "Create Role",
  fillRoleData: "Fill New Role Data",
  save: "Save",
  addCompany: "Add Company",
  editCompany: "Edit Company",
  companyFormSubtitle: "Enter the company details and main information",
  mainInformation: "Main Information",
  attachments: "Attachments",
  cancel: "Cancel",
  close: "Close",
  create: "Create",
  update: "Update",
  somethingWentWrong: "Something went wrong. Please try again.",
  companyNameEnglish: "Company Name (English)",
  companyNameArabic: "Company Name (Arabic)",
  enterNameEnglish: "Enter your name in English",
  enterNameArabic: "Enter your name in Arabic",
  address: "Address",
  email: "Email",
  enterEmail: "Enter your email",
  phoneNumber: "Phone Number",
  companyPhoneNumber: "Company Phone Number",
  fax: "Fax",
  faxPlaceholder: "Fax",
  notes: "Notes",
  notesPlaceholder: "Notes or details",
  delete: "Delete",
  confirmDeleteCompanyAdmin:
    "Are you sure you want to delete this company admin?",
  deleteWarning: "This action is permanent and cannot be undone.",
  typeDeleteToConfirm: 'Type "{{deleteWord}}" to confirm deletion',
  company: "Company",
  selectCompany: "Select company",
  companyName: "Company Name",
  createAdmin: "Create Admin",
  adminDetails: "Details and Main Info",
  companyManagement: "Companies",
  subscriptions: "subscriptions",
  SubscriptionSubTitle:
    "Subscription management and company-specific licensing limits.",
  createSubscriptions: "add new subscription",
  search: "search",
  selectSearchPlaceholder: "Search...",
  selectNoResults: "No results found.",
  addSubscription: "add subscription",
  subscripeSubTitle:
    "Create the subscription and set the company's license limits",
  chooseCompany: "Choose company",
  noChoice: "No Choices",
  moduleSubscriptions: "Subscriptions",
  totalPrice: "Total Price",
  view: "view",
  edit: "edit",
  searchMaxLength: "Max length of char 100",
  searchInvalid: "Can't search with empty string",
  moduleSub:
    "Choose the modules included in this subscription. Prices can be customized as needed.",
  price: "price",
  durations: "duration",
  startDate: "start date",
  endDate: "end date",
  yearly: "Annual",
  monthly: "Monthly",
  areYouSureToLogout: "Are you sure to logout ?",
  logout: "Log out",
  youWillBeLoggedOut: "You will be logged out",
  duration: "Duration",
  companyDetail: "Company Subscription and License Limit Definition",
  history: "History",
  current: "Current",
  future: "Future",
  companyInfo: "Company Details",
  companyName2: "company name",
  searchCompanyName: "search by company name",
  noCompaniesFound: " No Companies Found",
  welcomeBack: "Welcome Back!",
  pleaseEnterCredentials: "Please Fill In Your Data To Login",
  userName: "User Name",
  password: "Password",
  didYouForgotPassword: "Forgot Password!",
  sessionTimedOut: "Session Expired. Please Login Again",
  modules: "Modules",
  noModulesFound: "No modules found",
  emptyHistoryMessage: "No history found.",
  emptyCurrentMessage: "No current subscription found.",
  emptyFutureMessage: "No Future subscription found.",
  addAttachment: "Add More Attachements",

  companyAttachments: {
    maxFiles: "Maximum {{count}} attachments are allowed.",
    maxFileSize:
      'The file "{{fileName}}" exceeds the maximum size of {{size}} MB.',
  },
  companyNameArRequired: "Arabic company name is required.",
  companyNameEnRequired: "English company name is required.",
  nameEnRequired: "English name is required.",
  nameArRequired: "Arabic name is required.",
  emailRequired: "Email is required.",
  phoneNumberRequired: "Phone number is required.",
  invalidPhoneNumber: "Invalid phone number.",
  phoneNumberDigitsOnly: "Phone number must contain digits only.",
  invalidSaudiPhoneNumber:
    "Saudi phone number must contain 9 digits and start with 5.",
  invalidEgyptPhoneNumber:
    "Egyptian phone number must contain 10 digits and start with 10, 11, 12, or 15.",
  invalidUaePhoneNumber:
    "UAE phone number must contain 9 digits and start with 5.",
  invalidJordanPhoneNumber:
    "Jordanian phone number must contain 9 digits and start with 7.",
  updateSub: "save update",
  halfYear: "Semi-annual",
  saudiRiyal: "SAR",
  active: "Active",
  companyNameAr: "Arabic Company Name",
  nameAr: "Arabic Name",
  nameEn: "English Name",
  loading: "Loading",
  username: "Username",
  companyAdminNameArRequired: "Arabic name is required.",
  companyAdminNameEnRequired: "English name is required.",
  usernameRequired: "Username is required.",
  invalidUsername:
    "Username must be 3 to 30 characters and contain only letters, numbers, dots, underscores, or hyphens.",
  companyRequired: "Company Name Required",
  inactive: "Inactive",
  duplicateFile: 'The file "{{fileName}}" has already been added.',
  noDuration: "no duration",
  pendingActivation: "Pending Activation",
  status: "Status",
  name: "Name",
  linkedCompany: "Linked Company",
  activateAccount: "Activate Account",
  confirmResendActivationLink:
    "Are you sure you want to resend the activation link to this user?",
  resendActivationLink: "Resend Activation Link",
  activationLinkSent: "Activation link sent successfully.",
  resendActivationLinkFailed: "Failed to resend activation link.",
  confirm: "Confirm",
  resendActivationLinkDescription:
    "A new activation link will be sent to the registered email, and the user can use it to activate their account.",
  extend: "extend",
  openNavigation: "Open navigation",
  closeNavigation: "Close navigation",
  primaryNavigation: "Primary navigation",
  notifications: "Notifications",

  tenantNotFound: {
    title: "404",
    description: "No workspace is registered at this address.",
  },

  // \u00AD is a soft hyphen: invisible everywhere except the 75px nav rail,
  // where these two single words are the only labels too wide to fit and have
  // no space to wrap at. Arabic needs none — every label fits there.
  businessModules: {
    core: "Core",
    fleetMonitoring: "Fleet",
    operations: "Operations",
    workforce: "Workforce",
    maintenance: "Mainte\u00ADnance",
    partsAndInventory: "Parts & Inventory",
    analyticsAndInsights: "Analytics & Insights",
    communications: "Communi\u00ADcations",
  },
  datePicker: {
    pickDay: "Pick a day:",
    pickPeriod: "Pick a period:",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    time: "Time",
    hours: "Hours",
    minutes: "Minutes",
    am: "AM",
    pm: "PM",
  },
  overCapacity: {
    title: {
      subscription: "Modules exceed the available limit",
      device: "Devices exceed the available limit",
    },
    heading: {
      subscription: "Some modules exceed the available limit",
      device: "The devices exceed the available limit",
    },
    message: {
      createSubscription:
        "The number of devices or users in the following modules is more than the subscription allows. The subscription will be created, and the extra will be charged as additional fees.",
      updateSubscription:
        "The number of devices or users in the following modules is more than the subscription allows. The modules will be added, and the extra will be charged as additional fees.",
      createDevice:
        "All the devices in your subscription are in use. The device will be created, and the extra will be charged as additional fees.",
      restoreDevice:
        "All the devices in your subscription are in use. The device will be restored, and the extra will be charged as additional fees.",
      activateDevice:
        "All the devices in your subscription are in use. The device will be activated, and the extra will be charged as additional fees.",
    },
    notice: {
      createSubscription:
        "The number of devices or users in the following modules is now more than the subscription allows. The subscription was created, and the extra will be charged as additional fees.",
      updateSubscription:
        "The number of devices or users in the following modules is now more than the subscription allows. The modules were added, and the extra will be charged as additional fees.",
      createDevice:
        "All the devices in your subscription were already in use. The device was created, and the extra will be charged as additional fees.",
      restoreDevice:
        "All the devices in your subscription were already in use. The device was restored, and the extra will be charged as additional fees.",
      activateDevice:
        "All the devices in your subscription were already in use. The device was activated, and the extra will be charged as additional fees.",
    },
    columns: {
      subscription: "Module",
      device: "Item",
      paid: "Available",
      current: "Current",
      additional: "Extra",
    },
    devices: "Devices",
    totalAdditional: "Total extra units",
    fees: {
      title: "Estimated additional fees",
      note: {
        subscription: "Calculated from each module's approved unit price",
        device: "Calculated from the approved price per device",
      },
    },
    cancel: "Cancel",
    ok: "OK",
    confirm: {
      createSubscription: "Confirm creation",
      updateSubscription: "Confirm save",
      createDevice: "Confirm creation",
      restoreDevice: "Confirm restore",
      activateDevice: "Confirm activation",
    },
    close: "Close the over-capacity warning",
  },
};

export default enCommon;
